import Component from '@glimmer/component';
import { action } from '@ember/object';
import logger from 'donor-elf-web/lib/logger';

interface ComponentArgs {
  error?: any; // the error object to log
  useLeftBorderCard?: boolean;
}

export default class GenericErrorComponent extends Component<ComponentArgs> {
  get useLeftBorderCard() {
    return this.args.useLeftBorderCard ?? false;
  }

  @action
  templateDidInsert() {
    if (this.args.error) {
      logger.error(this.args.error);
    }
  }
}
